import React from "react";

export default class Section extends React.Component
{
    heading (heading, headingClasses = "", headingTag = "h1")
    {
        if (heading && typeof heading !== "undefined" && headingTag === "h1") 
            return <h1 className={`h-large h-faded ${ headingClasses }`}>{ heading }</h1>
        else if(heading && typeof heading !== "undefined" && headingTag === "h2")
            return <h2 className={`h-large h-faded ${ headingClasses }`}>{ heading }</h2>
        else if(heading && typeof heading !== "undefined" && headingTag === "h3")
            return <h3 className={`h-faded ${ headingClasses }`}>{ heading }</h3>
        else if(heading && typeof heading !== "undefined" && headingTag === "h5")
            return <h5 className={`h-faded ${ headingClasses }`}>{ heading }</h5>
        else if(heading && typeof heading !== "undefined" && headingTag === "div")
            return <div className={`h-large h-faded ${ headingClasses }`}>{ heading }</div>
    }

    content (content)
    {
        if (content && typeof content !== "undefined")
            return <div dangerouslySetInnerHTML={{ __html: content }} />
    }

    reversed (reversed, className)
    {
        if (reversed)
        {
            if (typeof className == "undefined")
                return "content-section-reversed";

            return className += " content-section-reversed";
        }

        return className;
    }

    render ()
    {
        let { heading, headingClasses, content, className, id, reversed, children, headingTag, divId, verticlePadding = true } = this.props;

        className = this.reversed(reversed, className);

        if (id)
            id = id.replace(/[\W_]+/g, "_").toLowerCase();

        return (
            <div id={ divId } className={ `${verticlePadding?"bkgd":""} bkgd_white ${className ?? ""}` } title={ heading }>
                { this.heading(heading, headingClasses, headingTag) }
                <div id={ id } className="body_text center">
                    { this.content(content) }
                    { children }
                </div>
            </div>
        );
    }
}